// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-progress-bar {
  width: 250px;
  padding-bottom: 2px;
  background: #c1c1c1;
  margin-top: 20px;
  position: relative;
}
.upload-progress-bar span {
  background: #f90047;
  display: block;
  height: 12px;
  border-radius: 2px;
  z-index: 3;
  position: relative;
  transition: 0.3s;
}
.upload-progress-bar span div {
  position: absolute;
  right: 4px;
  color: white;
  font-size: 10px;
  margin-top: 2px;
}
.upload-progress-bar:after {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  background: #e9e9e9;
  display: block;
  height: 12px;
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
